module.exports = __webpack_public_path__ + "M2_Factors Relevant to Me-8ad3eca5ffa5b82b4abb5832424ec34a.png";